import React from "react";
import { motion } from "framer-motion";
import { useContent } from "../../hooks/useContent";

const defaultReviews = [
  "Visionary design team.", "Exceptional technical execution.", "Unmatched quality.", "Future-proof development."
];

const Testimonials = () => {
  const { content } = useContent("ticker");
  const reviews = content?.texts?.length > 0 ? content.texts : defaultReviews;
  const speed = content?.speed || 20;

  return (
    <section className="py-20 bg-accent overflow-hidden">
      <div className="flex whitespace-nowrap">
        <motion.div
          key={`ticker-${speed}`}
          className="flex gap-12"
          animate={{ x: "-100%" }}
          transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
        >
          {[...reviews, ...reviews, ...reviews].map((review, i) => (
            <h2 key={i} className="text-6xl md:text-9xl font-display font-bold text-black uppercase tracking-tighter">
              {review} —
            </h2>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
